import React, { useState, useEffect } from 'react';

const TypeWriter = ({ text, delay = 9000, writeSpeed = 100, deleteSpeed = 75 }) => {
    const [displayedText, setDisplayedText] = useState('');
    const [isDeleting, setIsDeleting] = useState(false);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        let timer;

        if (isDeleting) {
            if (displayedText.length === 0) {
                setIsDeleting(false);
                setIndex(0);
                timer = setTimeout(() => {}, delay);
            } else {
                timer = setTimeout(() => {
                    setDisplayedText(current => current.slice(0, -1));
                }, deleteSpeed);
            }
        } else {
            if (index < text.length) {
                timer = setTimeout(() => {
                    setDisplayedText(current => current + text.charAt(index));
                    setIndex(current => current + 1);
                }, writeSpeed);
            } else {
                timer = setTimeout(() => {
                    setIsDeleting(true);
                }, delay);
            }
        }

        return () => clearTimeout(timer);
    }, [displayedText, isDeleting, index, text.length, delay, writeSpeed, deleteSpeed]);

    return <span>{displayedText}</span>;
};

export default TypeWriter;
